import { Component, Injector } from '@angular/core';
import { IGenericListOptions } from '@app/core/interfaces/commons';

import { GenericListComponent } from '@core/globals/generic-list/generic-list.component';


@Component({
  selector: 'app-contractors-list',
  templateUrl: './contractors-list.component.html',
  styles: []
})
export class ContractorsListComponent extends GenericListComponent {

    public readonly contractorListOptions: IGenericListOptions = {
      disabledColumns: {
        location__country: true,
      }
    };
  constructor(public injector: Injector) {
    super(injector);
    this.localDisabledColumns = this.contractorListOptions.disabledColumns;
  }
}


